var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fill-height editor-template"},[_c('div',{staticClass:"overflow-hidden editor-template__content",style:({
      height: `calc(100% - ${_vm.IMAGE_EDITOR_TOOLBAR_HEIGHT}px)`,
    })},[_vm._t("default")],2),_vm._v(" "),_c('ActionsToolbar',{staticClass:"editor-template__toolbar"},[_vm._t("toolbar")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }